export default __webpack_public_path__ + "static/media/02d556ef6367cb7b670d2adb0f764407.svg";